<div class="outer-container">
    <div class="workspace-container">
        <button class="cancel-btn" (click)="handleCancel()">
            <img src="assets/24x24/arrow-left-circle.svg" alt="">
            <span>Cancel</span>
        </button>
        <app-button theme="primary" size="xsmall" (click)="handlePlan()" [disabled]="planDetails.invalid">{{buttonText}}</app-button>
    </div>
    <form [formGroup]="planDetails">
        <app-loader class="loader" *ngIf="loaderView"></app-loader>
                <div class="wrapper-container" *ngIf="!loaderView">
                    <h2 class="section-title">{{isEdit? 'Edit' : 'Create'}} Subscription Plan</h2>
                    <div class="workspace-details-container">
                        <div class="workspace-info">
                            <div>
                                <p class="label">Plan Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="E.g., Basic Plan" type="text" name="planName"
                                    formControlName="planName"
                                    [value]="planDetails.controls['planName'].value!"
                                    (change)="onInputChange('planName',$event)" class="text-field" [hasError]="planDetailsHasError('planName')"></app-text-field>
                                    <small *ngIf="planDetailsHasError('planName')" class="error-message">Please enter a valid plan name</small>
                            </div>
                            <div>
                                <p class="label">Number of workspace owners <span class="required-star">*</span></p>
                                <app-text-field placeholder="E.g., 2" type="number" name="numWorkspaceOwners"
                                    formControlName="numWorkspaceOwners"
                                    [value]="planDetails.controls['numWorkspaceOwners'].value!"
                                    (change)="onInputChange('numWorkspaceOwners',$event)" [disabled]="isEdit" class="text-field" [hasError]="planDetailsHasError('numWorkspaceOwners')"></app-text-field>
                                    <small *ngIf="planDetailsHasError('numWorkspaceOwners')" class="error-message">Please enter a valid workspace owner count</small>
                            </div>
                            <div>
                                <p class="label">Number of End Users <span class="required-star">*</span></p>
                                <app-text-field placeholder="E.g., 2,000" type="number" name="numEndUsers"
                                    formControlName="numEndUsers"
                                    [value]="planDetails.controls['numEndUsers'].value!"
                                    (change)="onInputChange('numEndUsers',$event)" [disabled]="isEdit" class="text-field" [hasError]="planDetailsHasError('numEndUsers')"></app-text-field>
                                    <small *ngIf="planDetailsHasError('numEndUsers')" class="error-message">Please enter a valid user count</small>
                            </div>
                            <div>
                                <p class="label">Number of IT Admins <span class="required-star">*</span></p>
                                <app-text-field placeholder="E.g., 10" type="number" name="numItAdmins"
                                    formControlName="numItAdmins"
                                    [value]="planDetails.controls['numItAdmins'].value!"
                                    (change)="onInputChange('numItAdmins',$event)" [disabled]="isEdit" class="text-field" [hasError]="planDetailsHasError('numItAdmins')"></app-text-field>
                                    <small *ngIf="planDetailsHasError('numItAdmins')" class="error-message">Please enter a valid admin count</small>
                            </div>
                            <div>
                                <p class="label">Number of Assets <span class="required-star">*</span></p>
                                <app-text-field placeholder="E.g., 5,000" type="number" name="numOfAssets"
                                    formControlName="numOfAssets"
                                    [value]="planDetails.controls['numOfAssets'].value!"
                                    (change)="onInputChange('numOfAssets',$event)" class="text-field" [hasError]="planDetailsHasError('numOfAssets')"></app-text-field>
                                    <small *ngIf="planDetailsHasError('numOfAssets')" class="error-message">Please enter a valid asset count</small>
                            </div>
                            <ng-container *ngIf="!isEdit">
                                <div>
                                <p class="label">Plan Duration <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="planDurationList" (value)="getDuration($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Duration'"
                                    [shouldEmitEmittedValue]="true"></app-generic-drop-down>
                            </div>
                            </ng-container>
                            <div>
                                <p class="label">Plan Fee <span class="required-star">*</span></p>
                                <app-text-field placeholder="E.g., ₹50,000" type="number" name="planFee"
                                    formControlName="planFee"
                                    [value]="planDetails.controls['planFee'].value!"
                                    (change)="onInputChange('planFee',$event)" [disabled]="isEdit" class="text-field" [hasError]="planDetailsHasError('planFee')"></app-text-field>
                                    <small *ngIf="planDetailsHasError('planFee')" class="error-message">Please enter a valid amount</small>
                            </div>
                             <ng-container *ngIf="!isEdit">
                                <div>
                                <p class="label">Select Currency <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="currenciesList" (value)="getCurrency($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Currency'"
                                    [shouldEmitEmittedValue]="true"></app-generic-drop-down>
                            </div>
                             </ng-container>
                        </div>
                        </div>
            </div>
            </form>
</div>